import { useState, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { enviroment } from '@utils/config';
import { message } from 'antd';

import userApi from '@api/userApi';
import userActions from '@state/user/actions';

import logoCelsia from '@assets/img/logo/LogoCelsiaBlanco.png';
import iconCelsia from '@assets/img/logo/SimboloCelsia.png';

import logoMubon from '@assets/img/logo/logomubon_compuesto.png';
import iconMubon from '@assets/img/logo/iconmubon.png';

function useBrandImage() {

  const dispatch = useDispatch();
  const clientTarget = useSelector(({ user }) => user.clientTarget);
  const [loading, setLoading] = useState(false);

  const images = useMemo(() => {

    const { properties } = clientTarget || {};
    if (!properties) {

      if (enviroment.platform === 'mubon') return { logo: logoMubon, icon: iconMubon };
      return { logo: logoCelsia, icon: iconCelsia };

    }

    const { logo, icon } = properties;
    return { logo, icon };

  }, [clientTarget]);

  const onError = useCallback(() => {

    const {
      properties: { id: propertyId },
    } = clientTarget || {};

    if (!propertyId) return;

    setLoading(true);
    userApi
      .getPropertiesById({ propertyId })
      .then((properties) => {

        const newClientTarget = { ...clientTarget, properties };
        dispatch(userActions.updateClientTarget(newClientTarget));
        setLoading(false);

      })
      .catch((resError) => {

        const { fem } = resError;
        message.error(fem);
        setLoading(false);

      });
    // eslint-disable-next-line
  }, [clientTarget]);

  return { ...images, onError, loading };

}

export default useBrandImage;
